import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageChanger from './LanguageChanger';
import { Typography, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { SettingsContext } from '../context';

const useStyles = makeStyles(theme => ({
  wrap: {
    textAlign: 'center'
  },
  textButton: {
    cursor: 'pointer'
  }
}));

/**
 * Footer with texts and Language Changer
 */
export default function Footer() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { language } = useContext(SettingsContext);

  return (
    <div className={classes.wrap}>
      <LanguageChanger />
      <Typography variant="body2" color="textSecondary" align="center">
        <Link className={classes.textButton} href={`/auth/${language}/privacy`}>
          {t('privacyPolicy')}
        </Link>
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        <Link
          className={classes.textButton}
          href={`/auth/${language}/agreement`}
        >
          {t('termsOfUse')}
        </Link>
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        <Link
          className={classes.textButton}
          href={`/auth/${language}/portfolio`}
        >
          {t('portfolio')}
        </Link>
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        © UPLATFORMA {new Date().getFullYear()}
      </Typography>
    </div>
  );
}
